import { img, thumbImg } from "@/lib/images";
import type { GalleryImage } from "@/components/feature/GalleryGrid";

// ============================================================
// Fotoarchiv Nostalgie
// ------------------------------------------------------------
// Alle Dateien liegen in Supabase unter
// site-images/balivwtour/nostalgia/
// Ein Bild austauschen = neue Datei mit demselben Namen
// hochladen. Der Pfad im Code bleibt unverändert.
// ============================================================

/** Collage im Einführungsblock (4 Motive) */
export const nostalgiaCollage = [
  {
    src: img("balivwtour/nostalgia/deutsche_pressegrp_may04_la.jpg"),
    alt: "Deutsche Pressegruppe zu Gast bei Bali VW Tour, Mai 2004",
    title: "Deutsche Pressegruppe, Mai 2004",
  },
  {
    src: img("balivwtour/nostalgia/meiers_seminar_2005_02_lar.jpg"),
    alt: "Seminar-Gruppe von Meiers Weltreisen in der Villa Kompiang, 2005",
    title: "Meiers Weltreisen Seminar, 2005",
  },
  {
    src: img("balivwtour/nostalgia/pressegrp_sia01_feb06_450.jpg"),
    alt: "Pressegruppe von Singapore Airlines mit Gery Nutz, Februar 2006",
    title: "Singapore Airlines Pressegruppe, Februar 2006",
  },
  {
    src: img("balivwtour/nostalgia/pressegrp01_mar05_large.jpg"),
    alt: "Pressegruppe zu Besuch bei Bali VW Tour, März 2005",
    title: "Pressegruppe, März 2005",
  },
];

/**
 * Foto pro Presse-Eintrag (Schlüssel = Nummer des Eintrags).
 * Einträge ohne Bild zeigen nur das Zeitungssymbol.
 */
export const pressPhotoByIndex: Record<number, string> = {
  1: img("balivwtour/nostalgia/vox_tours01_large.jpg"),
  3: img("balivwtour/nostalgia/pressegrp_sia01_feb06_450.jpg"),
  4: img("balivwtour/nostalgia/meiers_fareast06_large.jpg"),
  5: img("balivwtour/nostalgia/meiers_educ_grp2006_01large.jpg"),
  6: img("balivwtour/nostalgia/filmteam01_juli_2005_large.jpg"),
  7: img("balivwtour/nostalgia/filmteam_mai25_2005_large.jpg"),
  8: img("balivwtour/nostalgia/meiers_seminar_2005_01_lar.jpg"),
  11: img("balivwtour/nostalgia/zeitungsber_sn_dez_04_large.jpg"),
  12: img("balivwtour/nostalgia/oest_pressegrp_jun04_large.jpg"),
};

/**
 * Fotos, die direkt einem Presse-Eintrag zugeordnet sind
 * (Schlüssel = Nummer des Eintrags).
 */
export const articlePhotosByIndex: Record<number, GalleryImage[]> = {
  1: [
    {
      key: "vox-tours-02",
      thumb: thumbImg("balivwtour/nostalgia/vox_tours02_large.jpg", 400),
      full: img("balivwtour/nostalgia/vox_tours02_large.jpg"),
      caption: "Das VOX-TOURS-Team unterwegs auf der Klassischen Tour",
      captionEn: "The VOX TOURS crew on the Classic Tour",
    },
  ],
  3: [
    {
      key: "pressegrp-sia-02",
      thumb: thumbImg("balivwtour/nostalgia/pressegrp_sia02_feb06_450.jpg", 400),
      full: img("balivwtour/nostalgia/pressegrp_sia02_feb06_450.jpg"),
      caption: "Pressegruppe Singapore Airlines in Mengwi, Februar 2006",
      captionEn: "Singapore Airlines press group in Mengwi, February 2006",
    },
  ],
  6: [
    {
      key: "filmteam-juli-2005",
      thumb: thumbImg("balivwtour/nostalgia/filmteam02_juli_2005_large.jpg", 400),
      full: img("balivwtour/nostalgia/filmteam02_juli_2005_large.jpg"),
      caption: "Fernsehteam bei den Dreharbeiten, Juli 2005",
      captionEn: "TV crew during filming, July 2005",
    },
  ],
  12: [
    {
      key: "pressegrp-nov-2004",
      thumb: thumbImg("balivwtour/nostalgia/pressegrp01_nov04_large.jpg", 400),
      full: img("balivwtour/nostalgia/pressegrp01_nov04_large.jpg"),
      caption: "Pressegruppe zu Besuch, November 2004",
      captionEn: "Press group visit, November 2004",
    },
  ],
  15: [
    {
      key: "pressegrp-maerz-2005",
      thumb: thumbImg("balivwtour/nostalgia/pressegrp01_mar05_large.jpg", 400),
      full: img("balivwtour/nostalgia/pressegrp01_mar05_large.jpg"),
      caption: "Pressegruppe zu Besuch, März 2005",
      captionEn: "Press group visit, March 2005",
    },
  ],
};